module.exports = __webpack_public_path__ + "static/sylvain_furlan-0158606e9edd233dca94e165a4c76f3a.jpg";